import { render } from "./QuoteDetails.vue?vue&type=template&id=3a045cf4"
import script from "./QuoteDetails.vue?vue&type=script&lang=js"
export * from "./QuoteDetails.vue?vue&type=script&lang=js"

import "./QuoteDetails.vue?vue&type=style&index=0&id=3a045cf4&lang=css"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__